import { Link } from "react-router-dom";
import AccordionArea from "../../components/AccordionArea";

const Accordion = () => {
  return (
    <div className="section4 bg-darkerFont py-[70px] px-4 sm:px-8 md:px-16 rounded-2xl ">
      <div className="container flex flex-col gap-16">
        <div className="inner flex flex-col xl:flex-row items-center xl:items-start gap-8 xl:gap-0">
          <div className="leftArea w-full xl:w-1/2 text-center xl:text-left">
            <h2 className="text-3xl md:text-4xl leading-[44px] md:leading-[58px] font-bold text-white">
              Sıkça Sorulan Sorular?
            </h2>
          </div>
          <div className="rightArea w-full xl:w-1/2">
            <p className="p-dark-style text-white text-center sm:text-left">
              Bu sayfa, aklınızdaki bazı soruları yanıtlamanıza yardımcı olacak.
              Eğer burada bulamadığınız bir sorunuz olursa, bizimle iletişime
              geçmekten çekinmeyin. Ekibinizle verimli bir şekilde çalışmanıza
              yardımcı olmayı hedefliyoruz!
            </p>
          </div>
        </div>
        <div className="accordionArea grid grid-cols-1 md:grid-cols-5 gap-8">
          <div className="col-span-1 flex justify-center md:justify-start">
            <img
              src="/gorsel.svg"
              alt="Accordion Image"
              className="max-w-full h-auto"
            />
          </div>
          <div className="accordion col-span-4 ">
            <AccordionArea page="home" />
          </div>
        </div>

        <div className="flex justify-center xl:justify-end">
          <Link
            to="/sikca-sorulan-sorular"
            className="bg-darkerFont text-darkerGreen py-3 px-4 rounded-xl max-w-[180px] text-center border-darkerGreen border-2 hover:border-greenn"
          >
            Tüm Soruları Gör
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Accordion;
